<template>
    <div class="video mt-4">
        <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <textarea :class="video != '' ? 'border-primary' : ''" id="inputVideo"
                v-model="video" @focus="forcusVideo" rows="2"></textarea>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': video != ''
                }">Thêm video</label>
        </div>
        <div class="d-flex justify-content-between">
            <div class="fs-12px text-note-img">* Enter để thêm nhiều video</div>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            video: ''
        }
    },
    watch: {
        data(val){
            this.video = val;
        },
        video(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.video = this.data;
    },
    methods:{
        forcusVideo(){
            this.$emit('update:error', '');
        }
    }
    
}
</script>
<style lang='scss'>
    .video{
        textarea{
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            display: block;
            width: 100%;
            border-radius: 4px;
            transition: border 0.15s linear;
            background-color: transparent;
            outline: none;
        }
    }
</style>
